// extracted by mini-css-extract-plugin
export var dateLabel = "_2l-0";
export var dateLabelError = "_2l-1";
export var fullWidth = "_2l-2";
export var smaller = "_2l-3";